// Both navigation views share one server-rendered collection response.
const collections = new Map();

function collectionProducts(path) {
  const url = new URL(path, location.origin);
  url.searchParams.set('section_id', 'absen-navigation-products');
  if (!collections.has(url.href)) {
    const request = fetch(url).then(async response => {
      if (!response.ok) throw new Error('Navigation products unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = html.querySelector('[data-absen-navigation-products]');
      if (!products) throw new Error('Navigation products missing');
      return { products, emptyImage: html.querySelector('[data-absen-empty-collection-image]') };
    });
    collections.set(url.href, request);
    request.catch(() => collections.delete(url.href));
  }
  return collections.get(url.href);
}

const visibleProducts = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    visibleProducts.unobserve(entry.target);
    entry.target.load();
  });
});

class AbsenNavigationProducts extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.loaded) visibleProducts.observe(this);
  }

  disconnectedCallback() {
    visibleProducts.unobserve(this);
  }

  async load() {
    this.setAttribute('aria-busy', 'true');
    try {
      const { products, emptyImage } = await collectionProducts(this.dataset.collection);
      const cards = [...products.children].slice(0, Number(this.dataset.limit));
      if (cards.length) {
        const links = cards.map(card => {
          const link = card.cloneNode(true);
          link.className = this.dataset.cardClass;
          return link;
        });
        // A collection link remains usable before loading and on a failed request.
        // Do not remove it from under a keyboard user's focus.
        const currentLink = this.querySelector('a');
        if (currentLink === document.activeElement) {
          this.append(...links);
          currentLink.addEventListener('blur', () => currentLink.remove(), { once: true });
        } else {
          this.replaceChildren(...links);
        }
      } else if (emptyImage) {
        this.querySelector('a')?.prepend(emptyImage.cloneNode(true));
      }
      this.dataset.loaded = 'true';
    } catch {
      this.dataset.loaded = 'error';
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

customElements.define('absen-navigation-products', AbsenNavigationProducts);
